import { render, staticRenderFns } from "./StudentApply.vue?vue&type=template&id=38af7208"
import script from "./StudentApply.vue?vue&type=script&lang=js"
export * from "./StudentApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports